'use client';

import { useEffect } from 'react';

// layout.tsx 에 한번만 등록되도록 처리
// [DEFECT-15304] 새로고침시 모달/팝업 노출을 막기 위해 진입시 hashbang 제거
export const useClearModalHashOnMount = () => {
  useEffect(() => {
    // 초기 타이밍 이슈로 setTimeout 필요!
    setTimeout(() => {
      const currentQuery = new URLSearchParams(window.location.search).toString();
      window.history.replaceState(null, '', currentQuery ? `?${currentQuery}` : '');
    }, 0);
  }, []);
};
